import { ProfileDropDown } from '../ProfileDropDown';
import { NotificationsDropdown } from '../Notifications';
import Logo from '../../assets/logo.svg';
import { Link, useLocation } from 'react-router-dom';
import { useBadge } from "../../context/badge";
import {ColleagueInfoPanel} from "../ColleagueInfoPanel";

export default function ManagerHeader() {
    const location = useLocation();
    const { newClaimsBadgeValue } = useBadge();

    const search = location.search;

    return (
        <div className="grid grid-flow-col place-content-stretch">
            <Link
                reloadDocument={true}
                to={{ pathname: '/claims', search }}
            >
                <img className='mr-2' src={Logo} alt='logo' />
            </Link>

            <div className='grid grid-flow-col gap-[5px] bg-white p-1 rounded-lg h-12 my-auto'>
                <Link
                    reloadDocument={true}
                    to={{ pathname: '/claims', search }}
                    className={'rounded-lg text-center py-2 flex items-center justify-center ' +
                        (location.pathname.endsWith('/claims') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    <span>Заявки</span>
                    {newClaimsBadgeValue > 0 && (
                        <span className="ml-2 bg-red-500 text-white text-center text-xs px-2 py-1 rounded-full">
                            +{newClaimsBadgeValue}
                        </span>
                    )}
                </Link>

                <Link
                    reloadDocument={true}
                    to={{ pathname: '/claims/in_work/', search }}
                    className={'rounded-lg text-center py-2 ' +
                        (location.pathname.startsWith('/claims/in_work/') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    В работе
                </Link>

                <Link
                    reloadDocument={true}
                    to={{ pathname: '/claims/postponed/', search }}
                    className={'rounded-lg text-center py-2 ' +
                        (location.pathname.startsWith('/claims/postponed/') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    Отложенные
                </Link>

                <Link
                    reloadDocument={true}
                    to={{ pathname: '/claims/finished/', search }}
                    className={'rounded-lg text-center py-2 ' +
                        (location.pathname.startsWith('/claims/finished/') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    Завершенные
                </Link>
            </div>

            <div className='grid grid-flow-col place-content-center justify-end gap-[10px]'>
                <NotificationsDropdown />
                <ProfileDropDown />
            </div>
        </div>
    );
}